const resolve = (dir) => require('path').join(__dirname, dir);

module.exports = {
  liningTitle: '渠道管理系统',
  projectIconPath: resolve(`./src/assets/images/${process.env.BRANCH_ENV}/favicon_BRAND_PIC.ico`), // 项目icon
  
  burgeonTarget: 'http://dev.burgeononline.com:8098',
  
  // liningTarget: 'http://cmsdev.lining.com', //李宁开发环境
  // jflowTarget: 'http://jflow.cmsdev.lining.com', //李宁开发环境jflow
  // SURVEY_URL: 'https://surveyqas-h5.lining.com/survery.vue.js',
  // SSO_URL: 'http://ssouat.lining.com/esc-sso/oauth2.0/authorize',
  // SSO_Client_Id: '99f595e7672f0145b9e8',
  
  // liningTarget: 'http://cmsqas.lining.com', //李宁QAS环境
  // jflowTarget: 'http://jflow.cmsqas.lining.com', //李宁QAS环境jflow
  
  liningTarget: 'http://cms.lining.com', //李宁PRD环境
  jflowTarget: 'https://jflow-cms.lining.com', //李宁PRD环境jflow
  SURVEY_URL: 'https://survey-h5.lining.com/survery.vue.js',
  SSO_URL: 'https://sso.lining.com/esc-sso/oauth2.0/authorize',
  SSO_Client_Id: '3fcdc4f3a868b9452df8',

};